import LogoutForm from "@arelia-components/api-authorization/LogoutForm";
import Header from "@arelia-components/layout/Header";
import { useSubscriptionDetailsAPI } from "@arelia-components/SubscriptionDetails/useSubscriptionDetailsAPI";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { useHasAppAccess } from "@arelia-hooks/useHasAppAccess";
import { Alert, Box, Button } from "@mui/material";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "src/AppContext";
import { PATHS } from "src/routes";
import SubscriptionPresenter from "./SubscriptionPresenter";

export default function SubscriptionContainer() {
  const { account } = useContext(AppContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navOptions = [
    { value: PATHS.PROFILE, label: "Profile" },
    { value: PATHS.CONNECTIONS, label: "Connections" },
    { value: PATHS.SUBSCRIPTION, label: "Subscription" },
    { value: PATHS.SECURITY, label: "Security" }
  ];

  const hasAppAccess = useHasAppAccess();
  const { data: userSubscription } = useSubscriptionDetailsAPI(account?.identityId);

  const action = <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} flexGrow="1">
    <LogoutForm>
      <Button type="submit" variant="contained" color="secondary">Logout</Button>
    </LogoutForm>
  </Box>;

  return (
    <ContentBox>
      {!hasAppAccess.hasAccess && <Alert variant="filled" severity="error" sx={styles.alert}>
        Your subscription ended. Please update subscription by 'Payment Options' or 'Change Plan'.
      </Alert>}
      {userSubscription?.scheduledForCancellation && <Alert variant="filled" severity="warning" sx={styles.alert}>
        Your subscription is scheduled for cancellation. If you change your mind and wish to continue with us, please use 'Payment Options'.
      </Alert>}
      <Header
        title="Account"
        action={action}
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <SubscriptionPresenter></SubscriptionPresenter>
    </ContentBox>
  );
}

const styles = {
  alert: {
    fontSize: "30px",
    '& .MuiAlert-icon': {
      fontSize: "60px"
    }
  }
}
